<section class="contact-section">
  <div class="content">
    <div class="title">
      {{info?.contactSection?.content?.title}}
    </div>
    <div class="sub-title">
      {{info?.contactSection?.content?.subTitle}}
    </div>
    <div class="desc">
      {{info?.contactSection?.content?.desc}}
    </div>
  </div>
  <div class="contact-links">
    <div class="email">
      <a [href]="'mailto:' + info?.contactSection?.contactLinks?.email">
        {{info?.contactSection?.contactLinks?.email}}
      </a>
    </div>
    <div class="call">
      <mat-icon>phone</mat-icon>
        <a [href]="'tel:' + info?.contactSection?.contactLinks?.phone">
          {{info?.contactSection?.contactLinks?.phone}}
        </a>
    </div>
  </div>
</section>